import type { Routes } from "@angular/router";
import { MobileDemandListPageComponent } from "./mobile-demand-list-page/mobile-demand-list-page.component";
import { MobileTicketWizardComponent } from "./mobile-demand-wizard-page/mobile-ticket-wizard-page.component";

/** Routes enfants sous `/mobile/eachat/demandes` (segment d’URL inchangé). */
export const authenticatedTicketDemandRoutes: Routes = [
  { path: "", component: MobileDemandListPageComponent },
  { path: ":ticketUid", component: MobileTicketWizardComponent },
];
